<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState, mapGetters, mapActions } from "vuex"
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Customer Balances",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect
  },
  data() {
    return {
      title: "Customer Balances ",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Customer Balances",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",

      // Value from user input for adding unit
      data: {
        name: "",
        contact: "",
      },
      // edit unit
      editdata: {
        name: "",
        balance: "",
        amount: "",
        id: "",
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
      },

      filterData: {
        branch_id: 0
      },

      balanceError: "",

      Balances: [],
      Advances: [],
      CustomersatZero: [],

      total_balance: 0,
      total_advance: 0,
      total_atzero: 0,

      json_fields: {
        NAME: "name",
        CONTACT: "contact",
        BALANCE: "balance",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("customers", ["SaveStatus", "CustomerBalances"]),
    ...mapGetters("auth", ["MyUserPerm", "Branches", "branchid"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "contact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "balance",
          sortable: true,
          label: "Balance",
        },
        {
          key: "details",
          sortable: true,
          label: "Details",
        }
      ];

      if (this.branchid==0) {
        baseFields.splice(4, 0,
          {
            key: "branch.name",
            sortable: true,
            label: "BRANCH",
          }       
        );
      }
      return baseFields;
    },

    /**
     * Total no. of records
     */

    rows() {
      return this.Balances ? this.Balances.length : 1;
    },

    rows2() {
      return this.Advances ? this.Advances.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.CustomerBalances ? this.CustomerBalances.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    CustomerBalances(newValue) {
      newValue.forEach(element => {
        if (element.balance > 0) {
          this.Advances.push(element);
        } else if (element.balance < 0) {
          this.Balances.push(element);
        } else if (element.balance == 0) {
          this.CustomersatZero.push(element);
        }
      });
    },
  },
  methods: {
    ...mapActions({
      FetchCustomerBalances: "customers/fetchCustomerBalances",
      AddCustomer: "customers/addCustomer",
      EditCustomer: "customers/editCustomer",
      DeleteCustomer: "customers/deleteCustomer",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    BalanceDetails(id) {
      this.$router.push(`/customer/balance_details/${btoa(id)}`);
    },

    fetchCustomerBalances() {
      this.FetchCustomerBalances(this.filterData);
    }

  },
  created() {
    this.FetchCustomerBalances();
  },

  updated() {
    let total_balance = 0;
    let total_advance = 0;
    if (this.Balances) {
      this.Balances.forEach((item) => {
        total_balance = total_balance + (item.balance);
      });
      this.total_balance = total_balance;
    }
    if (this.Advances) {
      this.Advances.forEach((item) => {
        total_advance = total_advance + (item.balance);
      });
      this.total_advance = total_advance;
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <b-tabs content-class="p-3 text-muted">

              <!-- ========================= TAB 1 ========================= -->
              <b-tab active class="border-0">

                <template v-slot:title>
                  <span>Debtors (Demanded by the Business)</span>
                </template>

                <div class="row mt-4 align-items-center">
                  <div class="col-md-3 mb-2">
                    <label class="d-flex align-items-center">
                      Show&nbsp;
                      <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                        :options="pageOptions"></b-form-select>
                      &nbsp;entries
                    </label>
                  </div>

                  <div class="col-md-3 mb-2 text-md-center">
                    <download-excel class="btn" style="background-color:#e612e6;border-color:#e612e6;color:#fff"
                      :data="Balances" :fields="json_fields"
                      :worksheet="'CUSTOMER BALANCES REPORT AS OF ' + currentdate" type="csv"
                      :name="'Customerbalances_report ' + currentdate + '.xls'">
                      Export <i class="fa fa-file-excel"></i>
                    </download-excel>
                  </div>

                  <div class="col-md-3 mb-2 text-md-end">
                    <label class="d-flex align-items-center justify-content-md-end">
                      Search:
                      <b-form-input v-model="filter" type="search" placeholder="Search..."
                        class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>

                  <div v-if="branchid == 0" class="col-md-3 mb-5">
                    <label>FILTER BY BRANCHES</label>
                    <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []"
                      v-model="filterData.branch_id" option-value="id" option-text="name" placeholder="Select Branch"
                      @input="fetchCustomerBalances()">
                      <option :value="0">All Branches</option>
                    </model-list-select>
                  </div>
                </div>

                <div class="table-responsive mb-0">
                  <b-table class="datatables" :items="Balances ? Balances : []" :fields="fields" responsive
                    :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                    :filter-included-fields="filterOn" @filtered="onFiltered">

                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>

                    <template #cell(balance)="data">
                      {{ thousandSeprator(-data.item.balance) }}
                    </template>

                    <template #cell(details)="data">
                      <button class="btn btn-sm" style="background-color:#e612e6;border-color:#e612e6;color:#fff"
                        @click="BalanceDetails(data.item.id)">
                        View Details
                      </button>
                    </template>

                  </b-table>

                  <div class="row mt-3">
                    <div class="col-12 text-center">
                      <h5>
                        Total Balances:
                        <span class="text-danger">{{ (-total_balance).toLocaleString() }}</span>
                      </h5>
                    </div>
                  </div>

                </div>

                <Loader v-if="!Balances" />

                <div class="row mt-3">
                  <div class="col-12 d-flex justify-content-md-end justify-content-center">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </div>
                </div>

              </b-tab>

              <!-- ========================= TAB 2 ========================= -->
              <b-tab class="border-0">

                <template v-slot:title>
                  <span>Creditors (Demanding the Business)</span>
                </template>

                <div class="row mt-4 align-items-center">

                  <div class="col-12 col-md-4 mb-2">
                    <label class="d-flex align-items-center">
                      Show&nbsp;
                      <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                        :options="pageOptions"></b-form-select>
                      &nbsp;entries
                    </label>
                  </div>

                  <div class="col-12 col-md-4 mb-2 text-md-center">
                    <download-excel class="btn" style="background-color:#e612e6;border-color:#e612e6;color:#fff"
                      :data="Advances" :fields="json_fields" :worksheet="'CUSTOMER ADVANCES REPORT FOR ' + currentdate"
                      type="csv" :name="'Customeradvances_report ' + currentdate + '.xls'">
                      Export <i class="fa fa-file-excel"></i>
                    </download-excel>
                  </div>

                  <div class="col-12 col-md-4 mb-2 text-md-end">
                    <label class="d-flex align-items-center justify-content-md-end">
                      Search:
                      <b-form-input v-model="filter" type="search" placeholder="Search..."
                        class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>

                </div>

                <div class="table-responsive mb-0">

                  <b-table class="datatables" :items="Advances ? Advances : []" :fields="fields" responsive
                    :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                    :filter-included-fields="filterOn" @filtered="onFiltered">

                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>

                    <template #cell(balance)="data">
                      {{ thousandSeprator(-data.item.balance) }}
                    </template>

                    <template #cell(details)="data">
                      <button class="btn btn-sm" style="background-color:#e612e6;border-color:#e612e6;color:#fff"
                        @click="BalanceDetails(data.item.id)">
                        View Details
                      </button>
                    </template>

                  </b-table>

                  <div class="row mt-3">
                    <div class="col-12 text-center">
                      <h5>
                        Total Advances:
                        <span class="text-danger">{{ (-total_advance).toLocaleString() }}</span>
                      </h5>
                    </div>
                  </div>

                </div>

                <Loader v-if="!Advances" />

                <div class="row mt-3">
                  <div class="col-12 d-flex justify-content-md-end justify-content-center">
                    <b-pagination v-model="currentPage" :total-rows="rows2" :per-page="perPage"></b-pagination>
                  </div>
                </div>

              </b-tab>

              <!-- ========================= TAB 3 ========================= -->
              <b-tab class="border-0">

                <template v-slot:title>
                  <span>With No Balance</span>
                </template>

                <div class="row mt-4 align-items-center">

                  <div class="col-12 col-md-4 mb-2">
                    <label class="d-flex align-items-center">
                      Show&nbsp;
                      <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                        :options="pageOptions"></b-form-select>
                      &nbsp;entries
                    </label>
                  </div>

                  <div class="col-12 col-md-4 mb-2 text-md-center">
                    <download-excel class="btn" style="background-color:#e612e6;border-color:#e612e6;color:#fff"
                      :data="CustomersatZero" :fields="json_fields"
                      :worksheet="'CUSTOMERS AT ZERO BALANCE REPORT AS OF ' + currentdate" type="csv"
                      :name="'Customersatzero_report ' + currentdate + '.xls'">
                      Export <i class="fa fa-file-excel"></i>
                    </download-excel>
                  </div>

                  <div class="col-12 col-md-4 mb-2 text-md-end">
                    <label class="d-flex align-items-center justify-content-md-end">
                      Search:
                      <b-form-input v-model="filter" type="search" placeholder="Search..."
                        class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>

                </div>

                <div class="table-responsive mb-0">

                  <b-table class="datatables" :items="CustomersatZero ? CustomersatZero : []" :fields="fields"
                    responsive :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc"
                    :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">

                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>

                    <template #cell(balance)="data">
                      {{ thousandSeprator(-data.item.balance) }}
                    </template>

                    <template #cell(details)="data">
                      <button class="btn btn-sm" style="background-color:#e612e6;border-color:#e612e6;color:#fff"
                        @click="BalanceDetails(data.item.id)">
                        View Details
                      </button>
                    </template>

                  </b-table>

                  <div class="row mt-3">
                    <div class="col-12 text-center">
                      <h5>
                        Total:
                        <span class="text-danger">{{ total_atzero }}</span>
                      </h5>
                    </div>
                  </div>

                </div>

                <Loader v-if="!CustomersatZero" />

                <div class="row mt-3">
                  <div class="col-12 d-flex justify-content-md-end justify-content-center">
                    <b-pagination v-model="currentPage" :total-rows="rows2" :per-page="perPage"></b-pagination>
                  </div>
                </div>

              </b-tab>

            </b-tabs>

          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}

.btn-xs {
  padding: .25rem .4rem;
  font-size: .875rem;
  line-height: .5;
  border-radius: .2rem;
}
</style>
